import * as React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker, IconSeeker } from "@ui-seeker/core"

import { useAdminBrandActions } from "../../@hooks"


export default function optionsColumn() {
    return {
        name: '', label: 'Options',
        options: {
            setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
            setCellProps: () => ({ sx: { textAlign: "center", maxWidth: 50 } }),
            filter: false,
            customBodyRowRender: (_, row) => <OptionsCell row={row} />
        }
    }
}

const OptionsCell = ({ row }) => {
    const { isClicked, isLoading, handleClickUpdateCreate, handleClickDelete } = useAdminBrandActions(row)

    let className = ''
    if (isLoading)
        className = 'is-loading'
    else if (isClicked)
        className = 'is-open'

    return <Box display="flex" justifyContent="center" alignItems="center" className={className}>
        { isLoading
            ? <IconSeeker isSpin icon="spinner" fontSize="1.5rem" />
            : <>
                <ButtonIconSeeker icon="pen" tooltip="Update" onClick={handleClickUpdateCreate} />
                <ButtonIconSeeker icon="trash" tooltip="Delete" onClick={handleClickDelete} />
            </>
        }
    </Box>
}